#import "../../../common/graphql/SecureRowLevelsEntityFields.graphql"
query BatchCommonData {
  companyCurrencies(orderBy: ISO_CODE_ASC) {
    nodes {
      id
      isoCode
      name
    }
  }
  batchTransactionWeeks {
    nodes {
      weekNumber
      _isHistory
    }
  }
  batchUsers {
    nodes {
      userId
      userName
    }
  }
  companyCorporatePeriods(
    filter: { isEntryAllowed: { equalTo: true } }
    orderBy: [IS_ENTRY_ALLOWED_DESC, START_DATE_ASC]
  ) {
    nodes {
      isEntryAllowed
      id
      _periodYear
      startDate
      endDate
    }
  }
  invoiceStatusTypes {
    nodes {
      id
      statusType
    }
  }
  secureRowLevels(orderBy: SECURITY_LEVEL_ASC) {
    nodes {
      ...SecureRowLevelsEntityFields
    }
  }
}
